'use client';

import { usePartnersSection } from '@/lib/hooks/useSiteData';

const PartnersSection = () => {
  const { data: partnersData, loading, error } = usePartnersSection();

  // Show loading state
  if (loading) {
    return (
      <section className="partner-sec">
        <div className="container">
          <div className="row align-items-center">
            <div className="col-lg-4">
              <div className="partner-heading">
                <div className="placeholder-glow">
                  <h2 className="placeholder col-10"></h2>
                </div>
              </div>
            </div>
            <div className="col-lg-8">
              <div className="row align-items-center p-list">
                {[1, 2, 3, 4, 5, 6].map((item) => (
                  <div key={item} className="col-lg-3 col-sm-6">
                    <div className="partner-logo">
                      <div 
                        className="placeholder" 
                        style={{ width: '100%', height: '80px', borderRadius: '8px' }}
                      ></div>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </section>
    );
  }

  // Show error or fallback state
  if (error || !partnersData?.data) {
    return (
      <section className="partner-sec">
        <div className="container">
          <div className="row align-items-center">
            <div className="col-lg-4">
              <div className="partner-heading">
                <h2>Current and Past Partners</h2>
              </div>
            </div>
            <div className="col-lg-8">
              <div className="row align-items-center p-list">
                <div className="col-lg-3 col-sm-6">
                  <div className="partner-logo">
                    <img src="/images/logos/atwf.png" alt="ATWF Logo" />
                  </div>
                </div>
                <div className="col-lg-3 col-sm-6">
                  <div className="partner-logo">
                    <img src="/images/logos/aarp.png" alt="AARP Logo" />
                  </div>
                </div>
                <div className="col-lg-3 col-sm-6">
                  <div className="partner-logo">
                    <img src="/images/logos/cb.jpg" alt="CB Logo" />
                  </div>
                </div>
                <div className="col-lg-3 col-sm-6">
                  <div className="partner-logo">
                    <img src="/images/logos/bw.jpg" alt="BW Logo" />
                  </div>
                </div>
                <div className="col-lg-3 col-sm-6">
                  <div className="partner-logo">
                    <img src="/images/logos/cw.png" alt="CW Logo" />
                  </div>
                </div>
                <div className="col-lg-3 col-sm-6">
                  <div className="partner-logo">
                    <img src="/images/logos/ccv.jpg" alt="CCV Logo" />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    );
  }

  // Process API data
  const title = partnersData?.data?.title || 'Current and Past Partners';
  const brandsSpec = partnersData?.data?.specifications?.find(
    (spec: any) => spec.key === 'brands'
  );
  const brands = brandsSpec?.value || [];

  return (
    <section className="partner-sec">
      <div className="container">
        <div className="row align-items-center">
          <div className="col-lg-4">
            <div className="partner-heading">
              <h2>{title}</h2>
            </div>
          </div>
          <div className="col-lg-8">
            <div className="row align-items-center p-list">
              {brands.map((brand: any, index: number) => (
                <div key={index} className="col-lg-3 col-sm-6">
                  <div className="partner-logo">
                    {brand.link && brand.link !== '/' ? (
                      <a href={brand.link} target="_blank" rel="noopener noreferrer">
                        <img 
                          src={brand.image} 
                          alt={`Partner ${index + 1}`}
                          onError={(e) => {
                            const target = e.target as HTMLImageElement;
                            target.src = '/images/logos/placeholder.png';
                          }}
                        />
                      </a>
                    ) : (
                      <img 
                        src={brand.image} 
                        alt={`Partner ${index + 1}`}
                        onError={(e) => {
                          const target = e.target as HTMLImageElement;
                          target.src = '/images/logos/placeholder.png';
                        }}
                      />
                    )}
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default PartnersSection;
